import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import nationalityApi from 'api/nationalityApi'

export const thunkNationlity = createAsyncThunk(
  'nationality/getAll',
  async (param, thunkApi) => {
    try {
      const res = await nationalityApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'nationality',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkNationlity.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkNationlity.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
